import { ControlConfig, IControlConfigArgs } from "../../business-objects/control/control-config.model";

export enum SplatControlConfigModelIconSizeEnum {
    SMALL,
    LARGE
}

export interface ISplatControlConfigArgs extends IControlConfigArgs {
    iconSize: SplatControlConfigModelIconSizeEnum;
}

const defaults = (): ISplatControlConfigArgs => ({
    ...new ControlConfig(),
    iconSize: 1
});

export class SplatControlConfig extends ControlConfig {

    iconSize: SplatControlConfigModelIconSizeEnum =
        SplatControlConfigModelIconSizeEnum.LARGE;

    constructor(data?: ISplatControlConfigArgs) {
        super({...defaults(), ...data});
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/splat-control-config.model.ts